import getFieldBaseName from '#support/utility/form/getFieldBaseName.js';

const sectionNameFromFullyQualifiedFieldName = (fullyQualifiedFieldName, fieldsByName) => {
  const firstField = getFieldBaseName(fullyQualifiedFieldName);
  const { section } = fieldsByName[firstField];
  return section;
};

export default sectionNameFromFullyQualifiedFieldName;
